import React from "react";

export const bowlingCenterWebsiteHref = (url) => {
  if (!url) return null;
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

export const bowlingCenterWebsiteLabel = (url) => {
  const href = bowlingCenterWebsiteHref(url);
  if (!href) return "Website";
  try {
    return new URL(href).hostname.replace(/^www\./, "");
  } catch {
    return "Website";
  }
};

const BowlingCenterInfo = ({ center, nameClassName }) => {
  if (!center) return null;

  const websiteHref = bowlingCenterWebsiteHref(center.website);
  const phoneDigits = (center.phone || "").replace(/\D/g, "");

  return (
    <>
      <a
        href={`https://www.google.com/maps/place/?q=place_id:${center.googlePlaceID}`}
        target="_blank"
        rel="noopener noreferrer"
        className={`block ${nameClassName}`}
      >
        {center.centerName}
      </a>
      {center.formattedAddress ? (
        <p className="text-brand-muted mt-1">{center.formattedAddress}</p>
      ) : null}
      {center.phone ? (
        <p className="text-brand-muted">
          <a href={`tel:${phoneDigits}`} className="hover:underline">
            {center.phone}
          </a>
        </p>
      ) : null}
      {websiteHref ? (
        <p className="text-brand-muted">
          <a
            href={websiteHref}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {bowlingCenterWebsiteLabel(center.website)}
          </a>
        </p>
      ) : null}
    </>
  );
};

export default BowlingCenterInfo;
